import { Typography } from '@mui/material'
import classNames from 'classnames'
import s from './AssessmentFragmentTitle.module.css'
import { getReportAssessmentAttributes } from 'entities/assessment'

interface AssessmentFragmentTitleProps {
  title: string
  deletable: boolean
  className?: string
}

export const AssessmentFragmentTitle = ({
  title,
  className,
  deletable,
}: AssessmentFragmentTitleProps) => {
  const assessmentAttributes = getReportAssessmentAttributes()

  return (
    <div
      className={classNames(s.wrapper, className, {
        [s.withDeleteButton]: deletable,
      })}
    >
      <Typography
        classes={{
          root: s.title,
        }}
      >
        {title}
      </Typography>
      <div className={s.icons}>
        <div className={s.iconWrapper}>
          {assessmentAttributes['ux-good'].icon}
        </div>
        <div className={s.iconWrapper}>
          {assessmentAttributes['ux-problem-low'].icon}
        </div>
        <div className={s.iconWrapper}>
          {assessmentAttributes['ux-problem-medium'].icon}
        </div>
        <div className={s.iconWrapper}>
          {assessmentAttributes['ux-problem-high'].icon}
        </div>
        <div className={s.iconWrapper}>{assessmentAttributes['task'].icon}</div>
        <div className={s.iconWrapper}>{assessmentAttributes['bug'].icon}</div>
      </div>
    </div>
  )
}
